import { Stack, Alert, Divider, Button } from "@mui/material";
import { useWebApiV1OrderQuery } from "@providers/hop-ord-server/api";
import { useNavigate, useParams } from "react-router-dom";
import { toLocaleDateTimeString } from "@utils";
import { UploadPanel } from "../components";
import PortaledMainBanner from "@pages/Layout/PortaledMainBanner";
import WarningIcon from "@mui/icons-material/Warning";
import BottomActionBar from "@pages/Layout/BottomActionBar";
import { OrderStatus } from "@enums";

const PlanReviewPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { data: orderData, isLoading: orderLoading } = useWebApiV1OrderQuery({
    orderId: Number(orderId),
  });

  const editingDatetime = orderData?.editingDatetime
    ? toLocaleDateTimeString(orderData?.editingDatetime || "")
    : "";

  if (orderLoading) {
    return <></>;
  }

  return (
    <>
      {orderData && !orderData?.isLatest && (
        <PortaledMainBanner>
          <Stack>
            <Alert
              severity="warning"
              sx={{ justifyContent: "center" }}
              icon={<WarningIcon />}
            >
              {`Dr ${orderData?.treatingRo} began editing this order at ${editingDatetime} and has not yet submitted the changes.`}
            </Alert>
            <Divider />
          </Stack>
        </PortaledMainBanner>
      )}
      <UploadPanel orderId={Number(orderId)} orderData={orderData} />
      <BottomActionBar>
        <Stack
          direction="row"
          width={1}
          justifyContent="flex-end"
          padding={2}
          gap={2}
          borderTop="1px solid"
          borderColor="divider"
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (orderData?.status === OrderStatus.SUBMITTED) {
                navigate(`/commandcenter/${orderId}`);
              } else {
                navigate(`/commandcenter/${orderId}/automated`);
              }
            }}
          >
            Back: Plan Generation
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`/commandcenter/${orderId}/handover`)}
          >
            Next: Handover
          </Button>
        </Stack>
      </BottomActionBar>
    </>
  );
};

export default PlanReviewPage;
